/**
 * Core
 */

import { rootRoutes, routeTicketEnum } from '@core/router/routeNames';

/**
 * Types
 */

import type { RoutesList } from '@core/router/routeNames';

const {
  NEW_TICKET,
  LIBRARY,
  DASHBOARD,
  TRANSPARENCY,
  PROFILE,
  NOT_FOUND,
  TECHNICAL_ERROR,
  UNAUTHORIZED,
  DEPOSIT_LIST,
} = routeTicketEnum;

const allowedRoutesByDefault: RoutesList[] = [
  rootRoutes.PROFILE,
  rootRoutes.NOT_FOUND,
  rootRoutes.TECHNICAL_ERROR,
  rootRoutes.UNAUTHORIZED,
];

/** Global app routes (ticket pages are gated by `runTicketNavigationGuard`). */
const allowedInitiatorRoutes: RoutesList[] = [
  NEW_TICKET,
  LIBRARY,
  DASHBOARD,
  PROFILE,
  NOT_FOUND,
  TECHNICAL_ERROR,
  UNAUTHORIZED,
  DEPOSIT_LIST,
];

const allowedFirstValidatorRoutes: RoutesList[] = [
  NEW_TICKET,
  DASHBOARD,
  TRANSPARENCY,
  LIBRARY,
  PROFILE,
  NOT_FOUND,
  TECHNICAL_ERROR,
  UNAUTHORIZED,
  DEPOSIT_LIST,
];

const allowedSecondValidatorRoutes: RoutesList[] = [
  NEW_TICKET,
  DASHBOARD,
  TRANSPARENCY,
  LIBRARY,
  PROFILE,
  NOT_FOUND,
  TECHNICAL_ERROR,
  UNAUTHORIZED,
  DEPOSIT_LIST,
];

export {
  allowedRoutesByDefault,
  allowedInitiatorRoutes,
  allowedFirstValidatorRoutes,
  allowedSecondValidatorRoutes,
};
